 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import PREFACE from '@/components/Preface'
 import INTRODUCTION from '@/components/Introduction'
 import PART1 from '@/components/Part1'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER3 from '@/components/Chapter3'
 import PART2 from '@/components/Part2'
 import CHAPTER4 from '@/components/Chapter4'
 import CHAPTER41 from '@/components/Chapter4-1'
 import CHAPTER42 from '@/components/Chapter4-2'
 import CHAPTER43 from '@/components/Chapter4-3'
 import CHAPTER44 from '@/components/Chapter4-4'
 import CHAPTER45 from '@/components/Chapter4-5'
 import CHAPTER46 from '@/components/Chapter4-6'
 import CHAPTER47 from '@/components/Chapter4-7'
 import CHAPTER48 from '@/components/Chapter4-8'
 import CHAPTER49 from '@/components/Chapter4-9'
 import CHAPTER410 from '@/components/Chapter4-10'
 import CHAPTER411 from '@/components/Chapter4-11'
 import CHAPTER412 from '@/components/Chapter4-12'
 import CHAPTER413 from '@/components/Chapter4-13'
 import CHAPTER414 from '@/components/Chapter4-14'
 import CHAPTER415 from '@/components/Chapter4-15'
 import CHAPTER416 from '@/components/Chapter4-16'
 import CHAPTER417 from '@/components/Chapter4-17'
 import CHAPTER418 from '@/components/Chapter4-18'
 import CHAPTER419 from '@/components/Chapter4-19'
 import CHAPTER420 from '@/components/Chapter4-20'
 import CHAPTER421 from '@/components/Chapter4-21'
 import CHAPTER422 from '@/components/Chapter4-22'
 import CHAPTER423 from '@/components/Chapter4-23'
 import CHAPTER424 from '@/components/Chapter4-24'
 import CHAPTER425 from '@/components/Chapter4-25'
 import CHAPTER426 from '@/components/Chapter4-26'
 import CHAPTER427 from '@/components/Chapter4-27'
 import CHAPTER428 from '@/components/Chapter4-28'
 import CHAPTER429 from '@/components/Chapter4-29'
 import CHAPTER430 from '@/components/Chapter4-30'
 import CHAPTER431 from '@/components/Chapter4-31'
 import CHAPTER432 from '@/components/Chapter4-32'
 import CHAPTER433 from '@/components/Chapter4-33'
 import CHAPTER434 from '@/components/Chapter4-34'
 import CHAPTER435 from '@/components/Chapter4-35'
 import CHAPTER436 from '@/components/Chapter4-36'
 import CHAPTER437 from '@/components/Chapter4-37'
 import CHAPTER438 from '@/components/Chapter4-38'
 import CHAPTER439 from '@/components/Chapter4-39'
 import CHAPTER5 from '@/components/Chapter5'
 import CHAPTER51 from '@/components/Chapter5-1'
 import CHAPTER52 from '@/components/Chapter5-2'
 import CHAPTER53 from '@/components/Chapter5-3'
 import CHAPTER54 from '@/components/Chapter5-4'
 import CHAPTER55 from '@/components/Chapter5-5'
 import CHAPTER56 from '@/components/Chapter5-6'
 import CHAPTER57 from '@/components/Chapter5-7'
 import CHAPTER58 from '@/components/Chapter5-8'
 import CHAPTER59 from '@/components/Chapter5-9'
 import CHAPTER510 from '@/components/Chapter5-10'
 import CHAPTER511 from '@/components/Chapter5-11'
 import CHAPTER512 from '@/components/Chapter5-12'
 import CHAPTER513 from '@/components/Chapter5-13'
 import CHAPTER514 from '@/components/Chapter5-14'
 import CHAPTER515 from '@/components/Chapter5-15'
 import CHAPTER516 from '@/components/Chapter5-16'
 import CHAPTER517 from '@/components/Chapter5-17'
 import CHAPTER518 from '@/components/Chapter5-18'
 import CHAPTER519 from '@/components/Chapter5-19'
 import CHAPTER520 from '@/components/Chapter5-20'
 import CHAPTER521 from '@/components/Chapter5-21'
 import CHAPTER522 from '@/components/Chapter5-22'
 import CHAPTER523 from '@/components/Chapter5-23'
 import CHAPTER524 from '@/components/Chapter5-24'
 import CHAPTER525 from '@/components/Chapter5-25'
 import CHAPTER526 from '@/components/Chapter5-26'
 import CHAPTER527 from '@/components/Chapter5-27'
 import CHAPTER528 from '@/components/Chapter5-28'
 import CHAPTER529 from '@/components/Chapter5-29'
 import CHAPTER530 from '@/components/Chapter5-30'
 import CHAPTER531 from '@/components/Chapter5-31'
 import CHAPTER532 from '@/components/Chapter5-32'
 import CHAPTER533 from '@/components/Chapter5-33'
 import CHAPTER534 from '@/components/Chapter5-34'
 import CHAPTER535 from '@/components/Chapter5-35'
 import CHAPTER536 from '@/components/Chapter5-36'
 import CHAPTER537 from '@/components/Chapter5-37'
 import CHAPTER538 from '@/components/Chapter5-38'
 import CHAPTER539 from '@/components/Chapter5-39'
 import CHAPTER540 from '@/components/Chapter5-40'
 import CHAPTER541 from '@/components/Chapter5-41'
 import CHAPTER542 from '@/components/Chapter5-42'
 import CHAPTER543 from '@/components/Chapter5-43'
 import CHAPTER544 from '@/components/Chapter5-44'
 import CHAPTER545 from '@/components/Chapter5-45'
 import CHAPTER546 from '@/components/Chapter5-46'
 import CHAPTER547 from '@/components/Chapter5-47'
 import CHAPTER548 from '@/components/Chapter5-48'
 import CHAPTER6 from '@/components/Chapter6'
 import CHAPTER61 from '@/components/Chapter6-1'
 import CHAPTER62 from '@/components/Chapter6-2'
 import CHAPTER63 from '@/components/Chapter6-3'
 import CHAPTER64 from '@/components/Chapter6-4'
 import CHAPTER65 from '@/components/Chapter6-5'
 import CHAPTER66 from '@/components/Chapter6-6'
 import CHAPTER67 from '@/components/Chapter6-7'
 import CHAPTER68 from '@/components/Chapter6-8'
 import CHAPTER69 from '@/components/Chapter6-9'
 import CHAPTER610 from '@/components/Chapter6-10'
 import CHAPTER611 from '@/components/Chapter6-11'
 import CHAPTER612 from '@/components/Chapter6-12'
 import CHAPTER613 from '@/components/Chapter6-13'
 import CHAPTER614 from '@/components/Chapter6-14'
 import CHAPTER615 from '@/components/Chapter6-15'
 import CHAPTER616 from '@/components/Chapter6-16'
 import CHAPTER617 from '@/components/Chapter6-17'
 import CHAPTER618 from '@/components/Chapter6-18'
 import CHAPTER619 from '@/components/Chapter6-19'
 import CHAPTER620 from '@/components/Chapter6-20'
 import CHAPTER621 from '@/components/Chapter6-21'
 import CHAPTER622 from '@/components/Chapter6-22'
 import CHAPTER623 from '@/components/Chapter6-23'
 import CHAPTER624 from '@/components/Chapter6-24'
 import CHAPTER625 from '@/components/Chapter6-25'
 import CHAPTER626 from '@/components/Chapter6-26'
 import CHAPTER627 from '@/components/Chapter6-27'
 import CHAPTER628 from '@/components/Chapter6-28'
 import CHAPTER629 from '@/components/Chapter6-29'
 import CHAPTER630 from '@/components/Chapter6-30'
 import CHAPTER631 from '@/components/Chapter6-31'
 import CHAPTER632 from '@/components/Chapter6-32'
 import CHAPTER633 from '@/components/Chapter6-33'
 import CHAPTER634 from '@/components/Chapter6-34'
 import CHAPTER635 from '@/components/Chapter6-35'
 import CHAPTER636 from '@/components/Chapter6-36'
 import CHAPTER637 from '@/components/Chapter6-37'
 import CHAPTER638 from '@/components/Chapter6-38'
 import CHAPTER639 from '@/components/Chapter6-39'
 import CHAPTER640 from '@/components/Chapter6-40'
 import CHAPTER641 from '@/components/Chapter6-41'
 import CHAPTER642 from '@/components/Chapter6-42'
 import CHAPTER643 from '@/components/Chapter6-43'
 import CHAPTER644 from '@/components/Chapter6-44'
 import CHAPTER645 from '@/components/Chapter6-45'
 import CHAPTER646 from '@/components/Chapter6-46'
 import CHAPTER647 from '@/components/Chapter6-47'
 import CHAPTER648 from '@/components/Chapter6-48'
 import CHAPTER649 from '@/components/Chapter6-49'
 import CHAPTER650 from '@/components/Chapter6-50'
 import CHAPTER651 from '@/components/Chapter6-51'
 import CHAPTER652 from '@/components/Chapter6-52'
 import CHAPTER653 from '@/components/Chapter6-53'
 import CHAPTER654 from '@/components/Chapter6-54'
 import CHAPTER655 from '@/components/Chapter6-55'
 import CHAPTER656 from '@/components/Chapter6-56'
 import CHAPTER7 from '@/components/Chapter7'
 import CHAPTER71 from '@/components/Chapter7-1'
 import CHAPTER72 from '@/components/Chapter7-2'
 import CHAPTER73 from '@/components/Chapter7-3'
 import CHAPTER74 from '@/components/Chapter7-4'
 import CHAPTER75 from '@/components/Chapter7-5'
 import CHAPTER76 from '@/components/Chapter7-6'
 import CHAPTER77 from '@/components/Chapter7-7'
 import CHAPTER78 from '@/components/Chapter7-8'
 import CHAPTER79 from '@/components/Chapter7-9'
 import CHAPTER710 from '@/components/Chapter7-10'
 import CHAPTER711 from '@/components/Chapter7-11'
 import CHAPTER712 from '@/components/Chapter7-12'
 import CHAPTER713 from '@/components/Chapter7-13'
 import CHAPTER714 from '@/components/Chapter7-14'
 import CHAPTER715 from '@/components/Chapter7-15'
 import CHAPTER716 from '@/components/Chapter7-16'
 import CHAPTER717 from '@/components/Chapter7-17'
 import CHAPTER718 from '@/components/Chapter7-18'
 import CHAPTER719 from '@/components/Chapter7-19'
 import CHAPTER720 from '@/components/Chapter7-20'
 import CHAPTER721 from '@/components/Chapter7-21'
 import CHAPTER722 from '@/components/Chapter7-22'
 import CHAPTER723 from '@/components/Chapter7-23'
 import CHAPTER724 from '@/components/Chapter7-24'
 import CHAPTER725 from '@/components/Chapter7-25'
 import CHAPTER726 from '@/components/Chapter7-26'
 import CHAPTER727 from '@/components/Chapter7-27'
 import CHAPTER728 from '@/components/Chapter7-28'
 import CHAPTER729 from '@/components/Chapter7-29'
 import CHAPTER730 from '@/components/Chapter7-30'
 import CHAPTER731 from '@/components/Chapter7-31'
 import CHAPTER732 from '@/components/Chapter7-32'
 import CHAPTER733 from '@/components/Chapter7-33'
 import CHAPTER734 from '@/components/Chapter7-34'
 import CHAPTER735 from '@/components/Chapter7-35'
 import CHAPTER736 from '@/components/Chapter7-36'
 import CHAPTER737 from '@/components/Chapter7-37'
 import CHAPTER738 from '@/components/Chapter7-38'
 import CHAPTER739 from '@/components/Chapter7-39'
 import CHAPTER740 from '@/components/Chapter7-40'
 import CHAPTER741 from '@/components/Chapter7-41'
 import CHAPTER742 from '@/components/Chapter7-42'
 import CHAPTER743 from '@/components/Chapter7-43'
 import CHAPTER744 from '@/components/Chapter7-44'
 import CHAPTER745 from '@/components/Chapter7-45'
 import CHAPTER746 from '@/components/Chapter7-46'
 import CHAPTER747 from '@/components/Chapter7-47'
 import CHAPTER748 from '@/components/Chapter7-48'
 import CHAPTER749 from '@/components/Chapter7-49'
 import CHAPTER750 from '@/components/Chapter7-50'
 import CHAPTER751 from '@/components/Chapter7-51'
 import CHAPTER752 from '@/components/Chapter7-52'
 import CHAPTER753 from '@/components/Chapter7-53'
 import CHAPTER754 from '@/components/Chapter7-54'
 import CHAPTER755 from '@/components/Chapter7-55'
 import CHAPTER756 from '@/components/Chapter7-56'
 import CHAPTER757 from '@/components/Chapter7-57'
 import CHAPTER758 from '@/components/Chapter7-58'
 import APPENDIX from '@/components/Appendix'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import COPYRIGHT from '@/components/Copyright'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Preface",
 			"name" : "Preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Part1",
 			"name" : "Part1",
 			"component" : PART1
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/Chapter2",
 			"name" : "Chapter2",
 			"component" : CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js